<template>
  <v-dialog
    v-model="dialogIsShown"
    max-width="500px"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="primary"
        x-small
        text
        class="pa-0"
      >
        Afficher
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="white--text secondary pa-4">
        Description de l'emploi vacant
      </v-card-title>

      <v-card-text
        v-html="description"
        style="max-height: 300px;"
        class="pa-4"
      ></v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="dialogIsShown = false"
        >
          Fermer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'JobDescDial',

  props: {
    description: String,
    value: Boolean,
  },

  computed: {
    dialogIsShown: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
